module.exports = __webpack_public_path__ + "static/404-42491de1a0ad9f7e5fd59ba9717afdb7.svg";